var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleLogoImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9218_2124)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.174 9.71058C18.174 8.93171 18.1121 8.36334 17.9782 7.77393H9.27246V11.2894H14.3825C14.2796 12.163 13.7232 13.4787 12.4869 14.3628L12.4695 14.4805L15.2221 16.659L15.4128 16.6784C17.1643 15.0259 18.174 12.5945 18.174 9.71058Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.27238 18.9729C11.7759 18.9729 13.8776 18.1308 15.4128 16.6783L12.4868 14.3627C11.7038 14.9205 10.6529 15.31 9.27238 15.31C6.82036 15.31 4.73924 13.6575 3.99738 11.3735L3.88864 11.383L1.02644 13.6459L0.989014 13.7522C2.51379 16.8467 5.64581 18.9729 9.27238 18.9729Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.9974 11.3736C3.80165 10.7842 3.68836 10.1526 3.68836 9.50004C3.68836 8.84742 3.80165 8.21592 3.9871 7.62651L3.98191 7.50098L1.08385 5.20166L0.989033 5.24774C0.360597 6.53185 0 7.97386 0 9.50004C0 11.0262 0.360597 12.4682 0.989033 13.7523L3.9974 11.3736Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.27238 3.69016C11.0135 3.69016 12.188 4.45851 12.8577 5.1006L15.4746 2.49029C13.8674 0.964108 11.7759 0.0273438 9.27238 0.0273438C5.64581 0.0273438 2.51379 2.15346 0.989014 5.2479L3.98708 7.62667C4.73924 5.34267 6.82036 3.69016 9.27238 3.69016Z",
    fill: "#EB4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9218_2124"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.1739,
    height: 19,
    rx: 9.08696,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogoImage);
export default __webpack_public_path__ + "static/media/googleLogoImage.e4f417038aee4ee27a0c17aea2f41e1d.svg";
export { ForwardRef as ReactComponent };